module.exports = __webpack_public_path__ + "img/user_group.2c71763b.svg";